 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"home":"home","explain":"explain","feedback":"feedback","switch":"switch","transfer":"transfer"}[chunkId]||chunkId) + "." + {"chunk-01a6f5cf":"f9635e46","chunk-05622395":"da5b25cf","chunk-05d1d9e0":"9e958ca6","chunk-0f7e77d8":"8216171c","chunk-19b3313c":"978ffdd6","chunk-19c66bf4":"d62aad2d","chunk-2d216257":"97e7aa3f","chunk-0e385e6b":"f2fa50cc","chunk-1d037572":"ee00caed","chunk-3fc4dd3c":"a7f61cf6","chunk-289721fe":"61019a46","chunk-42710ec7":"da0fd363","home":"ac0ae929","chunk-24570e6f":"cf877cee","chunk-2613bb34":"28b209ce","chunk-6e714126":"ceadc123","chunk-28adeed0":"09ec1b4f","chunk-32babb2a":"d4e24ffb","chunk-3b779476":"6d91b7fa","chunk-3bc23806":"9b9f33ad","chunk-3f7104b2":"2b4bfa17","chunk-17d6dd82":"7b96077d","chunk-6d62381c":"64e008b6","chunk-432bd832":"a7827e5f","chunk-4940aacc":"b83e8110","chunk-4dbd773f":"e3795ae2","chunk-4e459652":"e6e4d122","chunk-502240ad":"969f49a1","chunk-52c77ac7":"b99efab3","chunk-549297ec":"17337201","chunk-5885bbf1":"3e0af1b9","chunk-5f526bd7":"72c50bdd","chunk-639918d5":"cad1bb8a","chunk-63dfed7c":"d9247d58","chunk-6ccfbe62":"71929fdb","chunk-6fac3796":"34c34513","chunk-7d08c349":"d3e40d33","chunk-9bef7a30":"5a9cbfdf","chunk-b2b1da8e":"be3204c8","chunk-cbd9f0c0":"2e6653a3","chunk-dbaca29a":"daddef1f","explain":"9c106d7f","feedback":"f6d5321c","switch":"432ed7f0","transfer":"3e9b5270"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-01a6f5cf":1,"chunk-05622395":1,"chunk-05d1d9e0":1,"chunk-0f7e77d8":1,"chunk-19b3313c":1,"chunk-0e385e6b":1,"chunk-1d037572":1,"chunk-289721fe":1,"home":1,"chunk-24570e6f":1,"chunk-2613bb34":1,"chunk-6e714126":1,"chunk-28adeed0":1,"chunk-32babb2a":1,"chunk-3b779476":1,"chunk-3bc23806":1,"chunk-3f7104b2":1,"chunk-17d6dd82":1,"chunk-6d62381c":1,"chunk-432bd832":1,"chunk-4940aacc":1,"chunk-4dbd773f":1,"chunk-4e459652":1,"chunk-502240ad":1,"chunk-52c77ac7":1,"chunk-549297ec":1,"chunk-5885bbf1":1,"chunk-5f526bd7":1,"chunk-639918d5":1,"chunk-63dfed7c":1,"chunk-6ccfbe62":1,"chunk-6fac3796":1,"chunk-7d08c349":1,"chunk-9bef7a30":1,"chunk-b2b1da8e":1,"chunk-cbd9f0c0":1,"chunk-dbaca29a":1,"explain":1,"feedback":1,"switch":1,"transfer":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"home":"home","explain":"explain","feedback":"feedback","switch":"switch","transfer":"transfer"}[chunkId]||chunkId) + "." + {"chunk-01a6f5cf":"52fe14c7","chunk-05622395":"8dcbd7ef","chunk-05d1d9e0":"416baacc","chunk-0f7e77d8":"8d4973f4","chunk-19b3313c":"c62f8304","chunk-19c66bf4":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-0e385e6b":"45865ddb","chunk-1d037572":"9302fbc7","chunk-3fc4dd3c":"31d6cfe0","chunk-289721fe":"669db8d2","chunk-42710ec7":"31d6cfe0","home":"79883ce8","chunk-24570e6f":"1d550796","chunk-2613bb34":"ed95e2a3","chunk-6e714126":"a165783a","chunk-28adeed0":"0bbe7682","chunk-32babb2a":"0500471b","chunk-3b779476":"b32d5c51","chunk-3bc23806":"b31b0965","chunk-3f7104b2":"e2189054","chunk-17d6dd82":"98d4d56f","chunk-6d62381c":"d4cc3401","chunk-432bd832":"a36e485f","chunk-4940aacc":"90997774","chunk-4dbd773f":"9d47810d","chunk-4e459652":"4d8f73ac","chunk-502240ad":"eeefe755","chunk-52c77ac7":"46b88c86","chunk-549297ec":"62b2e6eb","chunk-5885bbf1":"068997d0","chunk-5f526bd7":"25f19a25","chunk-639918d5":"7bdb1693","chunk-63dfed7c":"53abf0b4","chunk-6ccfbe62":"f48d8fb0","chunk-6fac3796":"892e3aaf","chunk-7d08c349":"d4bc0f75","chunk-9bef7a30":"5f7b3eec","chunk-b2b1da8e":"0693d871","chunk-cbd9f0c0":"f426da05","chunk-dbaca29a":"00337054","explain":"96e9e54b","feedback":"87ba38d4","switch":"39d6bf74","transfer":"c95c63d4"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
